import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CAROUSELBLOCK_LEGACY_FIELD_ORDER = [
  "background_color",
  "layout",
  "position_sticky",
  "position_sticky_top"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  carouselBlockDescriptor: _generatedCarouselBlockDescriptor,
  carouselBlockBlocDefinition,
  carouselBlockDashboardLayout,
  carouselBlockConfig,
  carouselBlockResolveConfig,
  carouselBlockProperties,
} = doodBlockConfig(
  {
    name: "Carousel",
    componentType: 'CarouselBlockComponent',
    category: 'content',
    description: "Carousel.",
    keywords: [],
    sharedFields: {}
,
    slots: [
      {
        key: 'slides',
        name: "pages.blocks.carousel.slides.label",
        accept: 'explicitOnly',
        allowedTypes: ["CarouselSlide.*"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.carousel.background-color.label",
      }
    }),
    layout: propertyValue({
      type: 'select',
      value: 'auto',
      options: {
        label: "pages.blocks.carousel.layout.label",
        help: "pages.blocks.carousel.layout.help",
        multiple: false,
        choices: [
          {
            value: 'auto',
            label: "pages.blocks.carousel.layout.options.auto",
          },
          {
            value: 'photos',
            label: "pages.blocks.carousel.layout.options.photos",
          },
          {
            value: 'brand_logos',
            label: "pages.blocks.carousel.layout.options.brand-logos",
          }
        ]
      }
    }),
    position_sticky: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.carousel.position-sticky.label",
        help: "pages.blocks.carousel.position-sticky.help",
      }
    }),
    position_sticky_top: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.carousel.position-sticky-top.label",
        help: "pages.blocks.carousel.position-sticky-top.help",
        placeholder: "",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'pages.blocks.carousel.tab.content.label',
        fieldsets: [
          {
            legend: 'pages.blocks.carousel.fieldset.slides.label',
            fields: ["slides"],
          },
          {
            legend: 'pages.blocks.carousel.fieldset.appearance.label',
            fields: ["background_color", "layout"],
          },
          {
            legend: 'pages.blocks.carousel.fieldset.sticky.label',
            fields: [
              "position_sticky",
              {
                prop: "position_sticky_top",
                visibleWhen: { position_sticky: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function carouselBlockDescriptor(): IBlockDescriptor;
export function carouselBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function carouselBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCarouselBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCarouselBlockDescriptor, carouselBlockProperties, fieldOrder);
}

export {
  carouselBlockBlocDefinition,
  carouselBlockDashboardLayout,
  carouselBlockProperties,
  carouselBlockConfig,
  carouselBlockResolveConfig,
};

export type CarouselBlockConfig = typeof carouselBlockConfig;
